import { render } from "./CartTableNotificator.vue?vue&type=template&id=4284b292"
import script from "./CartTableNotificator.vue?vue&type=script&lang=js"
export * from "./CartTableNotificator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__